export default __webpack_public_path__ + "static/media/wallpaper.a6724790.png";